import './styles/index.scss';
import { withI18n } from 'panda-i18n';
import locale from "../../locales";
import { CnPullToRefresh as UICnPullToRefresh } from './pull-to-refresh';
export var CnPullToRefresh = withI18n(UICnPullToRefresh, { locale: locale });
